import React from "react"
import styled from "styled-components"
import { Card } from "../Card"

interface IconData {
  icon_name: string
  icon_link: string
  url: string
}

interface TechIconProps {
  keyId: number
  title: string
  iconDetails: Record<string, IconData[]>
}

const StyledCard = styled(Card)`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 334px;
  height: 350px;
  cursor: pointer;
  background-color: ${(props) => props.theme.midnightNavy};

  &:hover {
    background-color: ${(props) => props.theme.oxfordBlue};
  }
  @media (max-width: 768px) {
    max-width: 700px;
  }

  @media (max-width: 500px) {
    max-width: 700px;
    height: 400px;
  }

  @media (max-width: 425px) {
    max-width: 500px;
    width: 100%;
    height: 400px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 32px 12px;
  box-sizing: border-box;

  p {
    font-family: Montserrat, sans-serif;
    font-weight: 500;
    font-size: 18px;
    line-height: 170%;
    color: #d9d9d9;
    margin: 0;
    flex-shrink: 0;
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  .content {
    flex: 1;
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 25px;
  }

  .tech-row {
    display: flex;
    justify-content: center;
    gap: 8px;
    width: 100%;
    flex-wrap: wrap;
  }

  .tech {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80px;
    gap: 8px;
    text-align: center;
  }

  .tech > .icons > img {
    object-fit: contain;
    width: 24px;
    height: 24px;
    @media (max-width: 500px) {
      width: 25px;
      height: 25px;
    }
  }

  .icon-name {
    font-family: Lato, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff99;
    display: flex;
    align-items: center;
    text-align: center;
    @media (max-width: 768px) {
      font-size: 0.875rem;
    }
  }
`

const ToolTechCardComponent: React.FC<TechIconProps> = ({
  keyId,
  title,
  iconDetails,
}) => {
  return (
    <StyledCard borderRadius={"40px"}>
      <Content>
        <p>{title}</p>
        <div className={"content"} key={keyId}>
          {Object.keys(iconDetails).map((value) => (
            <div className={"tech-row"} key={value}>
              {iconDetails[value].map((item) => (
                <a href={item?.url} target={"_blank"} key={item.icon_name}>
                  <div className={"tech"}>
                    <div className={"icons"}>
                      <img src={item.icon_link} alt={item.icon_name} />
                    </div>
                    <div className={"icon-name"}>{item.icon_name}</div>
                  </div>
                </a>
              ))}
            </div>
          ))}
        </div>
      </Content>
    </StyledCard>
  )
}

export { ToolTechCardComponent }
